import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Alert, AlertTitle } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useActorBoundary } from '@application/common/hooks/useActorBoundary';
import { useBoundRequest } from '@application/common/hooks/useBoundRequest';
import { FaqtoringApi } from '@infrastructure/faqtoring-api';
export function FaqtoringAvailabilityHint() {
    const { t } = useTranslation('faqtoring');
    const actor = useActorBoundary();
    const data = useBoundRequest(`faqtoring-upload-availability:${actor.actor}`, () => actor.read(FaqtoringApi.availability));
    if (actor.changed || data.status === 'loading')
        return null;
    return _jsxs(Alert, { severity: 'info', sx: { mb: 2 }, children: [_jsx(AlertTitle, { children: t('title') }), t(data.status === 'error' ? 'availability.unknown' : data.data?.enabled ? 'availability.uploadHint' : 'availability.soon')] });
}
